/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_ExploreInputs */

const en_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const ar_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف`)
};

const bn_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সপ্লোর`)
};

const de_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken`)
};

const es_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const fr_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer`)
};

const pt_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar`)
};

const zh_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const tr_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfet`)
};

const ru_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть`)
};

const pl_pc_explore = /** @type {(inputs: Pc_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksploruj`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Pc_ExploreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const pc_explore = /** @type {((inputs?: Pc_ExploreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_ExploreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_pc_explore(inputs)
	if (locale === "bn") return bn_pc_explore(inputs)
	if (locale === "de") return de_pc_explore(inputs)
	if (locale === "es") return es_pc_explore(inputs)
	if (locale === "fr") return fr_pc_explore(inputs)
	if (locale === "pt") return pt_pc_explore(inputs)
	if (locale === "zh") return zh_pc_explore(inputs)
	if (locale === "tr") return tr_pc_explore(inputs)
	if (locale === "ru") return ru_pc_explore(inputs)
	if (locale === "pl") return pl_pc_explore(inputs)
	return en_pc_explore(inputs)
});